import { render, staticRenderFns } from "./ListOrganizationNews.vue?vue&type=template&id=44c28494"
import script from "./ListOrganizationNews.vue?vue&type=script&lang=js"
export * from "./ListOrganizationNews.vue?vue&type=script&lang=js"
import style0 from "./ListOrganizationNews.vue?vue&type=style&index=0&id=44c28494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports